<template>
  <div v-loading="loading">
    <h2 class="u-pl5 u-mt5">Smoke tests</h2>
    <el-dropdown split-button class="u-ml5 u-mb3" @click="queueNewRun">
      Run Smoke Tests
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="queueNewRunWithCustomCommitId">Run from custom commit_id</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-table class="u-ml5 u-mr5" :data="smokeTests">
      <el-table-column
          label="Operations"
          width="270">
        <template slot-scope="scope">
          <a :href="scope.row.external_url" target="_blank">
            <el-button :disabled="!scope.row.external_url">
              See on Cypress Dashboard
            </el-button>
          </a>
        </template>
      </el-table-column>
      <el-table-column
          prop="status"
          label="Status"
          width="180">
        <template slot-scope="scope">
          <ba-status-label :build="scope.row"></ba-status-label>
        </template>
      </el-table-column>

      <el-table-column
          prop="queued_at"
          label="Queued At"
          width="180"
      >
        <template slot-scope="scope">
          <div>{{scope.row.queued_at |
            moment('YYYY-MM-DD HH:mm')}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Completed">
        <template slot-scope="scope">
          <ba-build-completed-date :at="scope.row.completed_at"></ba-build-completed-date>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  import config from '@/config'
  import axios from 'axios'

  export default {
    props: ['buildId', 'commitId'],
    name: 'ba-desktop-build-smoke-tests',
    data () {
      (async () => {
        await this.loadRuns()
      })()

      return {
        loading: true,
        smokeTests: [],
        selectedDeployment: null,
      }
    },
    methods: {

      smokeTestUrlForBuild () {
        return config.url + '/desktop-build/' + this.buildId + '/smoke-tests/'
      },
      async queueNewRunWithCustomCommitId () {
        let {commitId} = await this.$prompt('Please type  git hash you want tests to run from:', 'Run smoke tests from custom commit', {
          confirmButtonText: 'Run Smoke Tests',
          cancelButtonText: 'Cancel',
          customClass: 'el-input-reset-password',
          inputValue: this.commitId,
        })

        await this.queueRunWithCommit(commitId)
      },
      async queueRunWithCommit (commitId = null) {
        try {
          this.loading = true
          await axios.post(this.smokeTestUrlForBuild(), {
            commit_id: commitId,
          })
          this.$notify({
            title: 'Success',
            message: 'Smoke Test Run has been queued...',
            type: 'success',
          })
        } catch (e) {
          this.loading = false
          this.$notify.error({
            title: 'Error',
            message: 'Failed to queue smoke test at this time',
          })
        }
        await this.loadRuns()
      },
      async queueNewRun () {
        await this.queueRunWithCommit()
      },
      async loadRuns () {
        this.loading = true
        let response = await axios.get(this.smokeTestUrlForBuild(), {})
        this.smokeTests = response.data
        this.loading = false
      },
    },
  }
</script>
